module.exports = __webpack_public_path__ + "static/img/section_plan.d5cbc9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/section_plan.png
// module id = Hnax
// module chunks = 0